import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "@mui/material";

import TextInput from "../../../ui/TextInput";

export default function CostWithPeriodField({
  costDefaultValue,
  globalCostDefault,
  costFieldName,
  currentCostValue,
  errors,
  periodDefaultValue,
  globalPeriodDefault,
  periodFieldName,
  currentPeriodValue,
  register,
}) {
  /** Change border color to orange if the value is overridden
   *
   * Adpated from code by Jon Middaugh. How to Change MUI TextField’s Border Color (Hover, Focus, Overrides, and More).
   * Retrieved from https://smartdevpreneur.com/override-textfield-border-color-in-material-ui/
   *
   * Note this style only works for TextField with outlined variant.
   */
  const borderStyle = {
    "& .MuiOutlinedInput-root": {
      "& > fieldset": { border: 2, borderColor: "orange" },
    },
  };

  const costOverridden =
    currentCostValue !== undefined && currentCostValue !== globalCostDefault;
  const periodOverridden =
    currentPeriodValue !== undefined &&
    currentPeriodValue !== globalPeriodDefault;

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Tooltip
        placement="top"
        title={
          costOverridden ? "Default: " + globalCostDefault.toLocaleString() : ""
        }
      >
        <div>
          <TextInput
            currentValue={currentCostValue}
            defaultValue={costDefaultValue}
            errors={errors}
            isRequired
            min={0}
            name={costFieldName}
            register={register}
            size="small"
            startAdornment="$"
            sx={
              costOverridden
                ? { marginBottom: "5px", maxWidth: "130px", ...borderStyle }
                : { marginBottom: "5px", maxWidth: "130px" }
            }
            type="number"
          />
        </div>
      </Tooltip>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "14px",
        }}
      >
        Every{" "}
        <Tooltip
          placement="top"
          title={periodOverridden ? "Default: " + globalPeriodDefault : ""}
        >
          <div>
            <TextInput
              defaultValue={periodDefaultValue}
              errors={errors}
              isRequired
              min={0}
              name={periodFieldName}
              register={register}
              size="small"
              step="1"
              inputProps={{
                sx: { fontSize: "14px", maxHeight: "25px", padding: "5px" },
              }}
              sx={
                periodOverridden
                  ? { margin: "0 5px", width: "50px", ...borderStyle }
                  : { margin: "0 5px", width: "50px" }
              }
              type="number"
            />
          </div>
        </Tooltip>{" "}
        years
      </div>
    </div>
  );
}

CostWithPeriodField.propTypes = {
  costDefaultValue: PropTypes.number.isRequired, // default value to shown in input field
  globalCostDefault: PropTypes.number.isRequired, // global default to check if value has been overridden
  costFieldName: PropTypes.string.isRequired,
  currentCostValue: PropTypes.number,
  errors: PropTypes.object.isRequired,
  periodDefaultValue: PropTypes.number, // default value to shown in input field
  globalPeriodDefault: PropTypes.number, // global default to check if value has been overridden
  periodFieldName: PropTypes.string.isRequired,
  currentPeriodValue: PropTypes.number,
  register: PropTypes.func.isRequired,
};
